<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">

      <template slot="menuLeft">
        <el-button type="success"
                   size="small"
                   icon="el-icon-s-check"
                   @click="handleActivate">激活</el-button>
      </template>
    </avue-crud>

    <ActivateAccount :key=ActivateAccount
                     ref="ActivateAccount"
                     :disabled="false"
                     :deptId="deptId" />
  </div>
</template>

<script>
import {
  getList,
  getDetail,
  add,
  update,
  remove,
} from '@/api/config/blade-config'
import crudmixins from '@/basic-common/mixins/crudmixins.js'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import ActivateAccount from '@/components/user/ActivateAccount.vue'

const mixin = new crudmixins({ add, getDetail, getList, remove, update })

export default {
  mixins: [mixin],
  data() {
    return {
      activateShow: false,
      ActivateAccount: false,
      option: {
        ...this.$store.state.publicOption,
        dialogWidth: '70%',
        span: 8,
        searchSpan: 8,
        labelWidth: 140,
        addBtnText: '生成激活码',
        deptId: '',
        column: [
          {
            label: '单位',
            prop: 'deptId',
            overHidden: true,
            type: 'tree',
            dataType: 'string',
            width: 120,
            searchMultiple: true,
            align: 'center',
            defaultExpandAll: true,
            checkStrictly: true,
            dicUrl: '/api/blade-system/dept/tree',
            props: {
              label: 'title',
              value: 'id',
            },
            search: true,
            rules: [
              {
                required: true,
                message: '请选择所属单位',
                trigger: 'change',
              },
            ],
          },
          {
            label: '项目名称',
            prop: 'projectName',
            overHidden: true,
            hide: true,
            viewDisplay: false,
            type: 'input',
            align: 'center',
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '数据',
            prop: 'data',
            span: 8,
            overHidden: true,
            addDisplay: false, //新增页面不显示
            type: 'input',
            align: 'center',
          },
          {
            label: '永久激活',
            prop: 'permanentActivation',
            overHidden: true,
            align: 'center',
            type: 'select',
            hide: true,
            viewDisplay: false,
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=yes_no',
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择是否永久激活',
                trigger: 'change',
              },
            ],
            // eslint-disable-next-line no-unused-vars
            change: ({ value, column }) => {
              switch (value) {
                case '1':
                  this.form.expiryDate = ''
                  this.form.reminderDay = ''
                  this.form.reportDay = ''
                  this.form.loginDay = ''
                  this.form.weightDay = ''
                  this.form.maintenanceDate = ''
                  this.form.maintenanceDay = ''
                  _.find(this.option.column, {
                    prop: 'expiryDate',
                  }).display = false
                  _.find(this.option.column, {
                    prop: 'reminderDay',
                  }).display = false
                  _.find(this.option.column, {
                    prop: 'reportDay',
                  }).display = false
                  _.find(this.option.column, {
                    prop: 'loginDay',
                  }).display = false
                  _.find(this.option.column, {
                    prop: 'weightDay',
                  }).display = false
                  _.find(this.option.column, {
                      prop: 'maintenanceDate',
                  }).display = false
                  _.find(this.option.column, {
                      prop: 'maintenanceDay',
                  }).display = false
                  break
                case '0':
                  _.find(this.option.column, {
                    prop: 'expiryDate',
                  }).display = true
                  _.find(this.option.column, {
                    prop: 'reminderDay',
                  }).display = true
                  _.find(this.option.column, {
                    prop: 'reportDay',
                  }).display = true
                  _.find(this.option.column, {
                    prop: 'loginDay',
                  }).display = true
                  _.find(this.option.column, {
                    prop: 'weightDay',
                  }).display = true
                  _.find(this.option.column, {
                      prop: 'maintenanceDate',
                  }).display = true
                  _.find(this.option.column, {
                      prop: 'maintenanceDay',
                  }).display = true
                  break
              }
            },
          },
          {
            label: '到期时间',
            prop: 'expiryDate',
            type: 'datetime',
            hide: true,
            viewDisplay: false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入到期时间',
                trigger: 'blur',
              },
            ],
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '提醒天数',
            prop: 'reminderDay',
            overHidden: true,
            hide: true,
            viewDisplay: false,
            type: 'number',
            precision: 0,
            align: 'center',
            rules: [
              {
                required: true,
                message: '请输入提醒天数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '到期停止报表天数',
            prop: 'reportDay',
            overHidden: true,
            type: 'number',
            precision: 0,
            hide: true,
            viewDisplay: false,
            align: 'center',
            rules: [
              {
                required: true,
                message: '请输入到期停止报表天数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '到期停止登录天数',
            prop: 'loginDay',
            overHidden: true,
            type: 'number',
            precision: 0,
            hide: true,
            viewDisplay: false,
            align: 'center',
            rules: [
              {
                required: true,
                message: '请输入到期停止登录天数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '到期停止检斤天数',
            prop: 'weightDay',
            overHidden: true,
            hide: true,
            viewDisplay: false,
            type: 'number',
            precision: 0,
            align: 'center',
            rules: [
              {
                required: true,
                message: '请输入到期停止检斤天数',
                trigger: 'blur',
              },
            ],
          },
            {
                label: '维保到期时间',
                prop: 'maintenanceDate',
                type: 'datetime',
                hide: true,
                viewDisplay: false,
                span: 8,
                rules: [
                    {
                        required: true,
                        message: '请输入维保到期时间',
                        trigger: 'blur',
                    },
                ],
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            {
                label: '维保提醒天数',
                prop: 'maintenanceDay',
                overHidden: true,
                hide: true,
                viewDisplay: false,
                type: 'number',
                precision: 0,
                align: 'center',
                rules: [
                    {
                        required: true,
                        message: '请输入维保提醒天数',
                        trigger: 'blur',
                    },
                ],
            },
        ],
      },
      data: [],
    }
  },
  components: {
    ActivateAccount,
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        //addBtn: this.vaildData(this.permission.driver_add, false),
        addBtn: false,
        viewBtn: this.vaildData(this.permission.driver_view, false),
        delBtn: false,
        editBtn: false,
      }
    },
    ids() {
      let ids = []
      this.selectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids.join(',')
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleActivate() {
      if (this.selectionList.length && this.selectionList.length > 1) {
        return this.$message.error('只能选择一条数据')
      }
      this.deptId = this.selectionList.length
        ? this.selectionList[0].deptId
        : null

      this.ActivateAccount = !this.ActivateAccount
      this.$nextTick(() => {
        this.$refs.ActivateAccount.handleShow()
      })
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data.data
        })
      }

      if (['add'].includes(type)) {
        this.$set(this.form, 'reminderDay', '7')
        this.$set(this.form, 'reportDay', '3')
        this.$set(this.form, 'loginDay', '0')
        this.$set(this.form, 'weightDay', '1')
        this.$set(this.form, 'maintenanceDay', '7')
      }
      done()
    },
  },
}
</script>

<style>
</style>
